import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { csvToJSON } from '../utils';


interface SaveOrderActions {
    saveOrder: (orderId: number, data: unknown) => void
}

interface OrderSavedItem {
    data: any;
    dateSaved: Date
}

const excludedKeys = ['saveOrder']

const useSaveOrderStore = create<Record<number, OrderSavedItem> & SaveOrderActions>()(devtools(persist((set, get) => {
    const cleanStorage = (orderId: number, data: unknown) => {
        let shouldCheck = true;
        while (shouldCheck) {
            const items = get();
            const jsonData = { ...items, [orderId]: { data, dateSaved: new Date() } }
            excludedKeys.forEach((key: any) => {
                if (jsonData[key]) {
                    delete jsonData[key];
                }
            })
            Object.keys(jsonData).forEach((key: any) => jsonData[key] === undefined ? delete jsonData[key] : {});
            const json = JSON.stringify(jsonData);
            const jsonSizeMB = json.length / 1000000
            const arr: { key: string; date: Date; }[] = [];
            if (jsonSizeMB >= 3) {
                if (Object.keys(jsonData).length === 1) {
                    throw new Error("Can't save data. too large.");
                }
                Object.keys(items).filter((key: string) => !excludedKeys.includes(key)).forEach(key => {
                    const index = Number.parseInt(key, 10)
                    arr.push({ key, date: items[index]?.dateSaved });
                })
                arr.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                if (arr[0]?.key) {
                    set({ [arr[0]?.key]: undefined })
                }
            } else {
                shouldCheck = false;
            }
        }
    }
    const setData = async (orderId: number, _data: unknown) => {
        const data: any & { file: FileList } = _data
        let dataWithFile: typeof data=data;
        if (data.file) {
            dataWithFile = await new Promise((res, rej) => {
                const [file] = data.file
                const reader = new FileReader();
                reader.readAsText(file, "UTF-8");
                reader.onload = (evt) => {
                    const csv = evt.target?.result as string;
                    const json = csvToJSON(csv);
                    const jsonObj = JSON.parse(json);
                    data.fileJson = { data: jsonObj, fileName: file.name }
                    res(data)
                }
                reader.onerror = () => {
                    rej(new Error("failed to read file."))
                }
            })
        }
        set(state => {
            const cData = state[orderId]?.data || {};
            return { [orderId]: { data: { ...cData, ...(dataWithFile as any) }, dateSaved: new Date() } }
        })
    }
    return {
        saveOrder: (orderId, data) => {
            cleanStorage(orderId, data)
            setData(orderId, data)
        }
    }
}, { name: 'saved-order-storage' })))

export default useSaveOrderStore